// Terms and Conditions Popup
//
//
// document.addEventListener('DOMContentLoaded', function() {
//   // Function to attach event listeners when the elements are available
//   function attachEventListeners() {
//     const termsCheckbox  = document.getElementById('cart-terms');
//     const modal          = document.getElementById('terms-modal');
//     const closeModal     = document.querySelector('.terms-modal-class .terms-close');
//     const agreeButton    = document.getElementById('terms-agree-button');
//     const declineButton  = document.getElementById('terms-decline-button');
//     const scrollableDiv  = document.querySelector('.terms-modal-content');
//     const scrollButton   = document.querySelector('.terms-scrollDown');
//     const checkoutButton = document.querySelector('button[name="checkout"]');

//     if (!termsCheckbox || !modal || !checkoutButton) {
//       return; // If necessary elements are missing, don't proceed
//     }

//     // Adds class .noScrollPopUp to the body of document & .show class to modal
//     termsCheckbox.addEventListener('click', function() {
//       if (termsCheckbox.checked) {
//         modal.classList.add('show');
//         document.body.classList.add("noScrollPopUp");
//       }
//     });

//     // Checkout button triggers modal if terms are not agreed upon
//     checkoutButton.addEventListener('click', function(event) {
//       if (!termsCheckbox.checked) {
//         event.preventDefault(); // Prevent checkout from proceeding
//         modal.classList.add('show'); // Show the terms modal
//         document.body.classList.add("noScrollPopUp");
//       }
//     });

//     // When the close icon is clicked, hide modal
//     closeModal.addEventListener('click', function() {
//       modal.classList.remove('show');
//       termsCheckbox.checked = false;
//       document.body.classList.remove("noScrollPopUp");
//     });

//     // Decline button closes modal and unchecks the terms checkbox
//     declineButton.addEventListener('click', function() {
//       modal.classList.remove('show');
//       termsCheckbox.checked = false;
//       document.body.classList.remove("noScrollPopUp");
//     });

//     // Close the modal if the user clicks outside of it
//     window.addEventListener('click', function(event) {
//       if (event.target == modal) {
//         modal.classList.remove('show');
//         termsCheckbox.checked = false;
//         document.body.classList.remove("noScrollPopUp");
//       }
//     });

//     // Allow the user to continue by clicking "Agree"
//     agreeButton.addEventListener('click', function() {
//       modal.classList.remove('show');
//       document.body.classList.remove("noScrollPopUp");
//       termsCheckbox.checked = true; // Ensure the terms checkbox is checked
//       checkoutButton.click(); // Proceed to checkout after agreeing
//     });

//     // Function to scroll to the bottom of the modal
//     scrollButton.addEventListener('click', function() {
//       scrollableDiv.scrollTop = scrollableDiv.scrollHeight;
//     });
//   }

//   // Initial call to attach the event listeners if elements are already available
//   attachEventListeners();

//   // Use MutationObserver to watch for changes in the DOM and reattach listeners when necessary
//   const observer = new MutationObserver(function(mutations) {
//     mutations.forEach(function(mutation) {
//       if (mutation.type === 'childList' || mutation.type === 'subtree') {
//         // Check if the cart has been updated and reattach event listeners
//         attachEventListeners();
//       }
//     });
//   });

//   // Start observing the document for changes in the DOM
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// });


//Image zoom functionality
//
//
function setupFullscreenZoom(selector) {
  const imageContainers = document.querySelectorAll(selector);

  imageContainers.forEach(image => {
    image.addEventListener('click', function(event) {
      openFullscreen(this, event);
    });
  });

  function openFullscreen(img, event) {
    // Create a full-screen container
    const fullscreenContainer = document.createElement('div');
    fullscreenContainer.classList.add('fullscreen-container');
    
    // Create the zoomed-in image
    const fullscreenImage = document.createElement('img');
    fullscreenImage.src = img.src;
    fullscreenImage.classList.add('fullscreen-image');

    // Append the image to the container
    fullscreenContainer.appendChild(fullscreenImage);
    document.body.appendChild(fullscreenContainer);

    let zoomed = false;

    // Zoom in based on click position
    fullscreenImage.addEventListener('click', function(e) {
      if (!zoomed) {
        zoomIn(fullscreenImage, e); // Zoom in on click
        zoomed = true;
      } else {
        zoomOut(fullscreenImage); // Zoom out on second click
        zoomed = false;
      }
    });

    // Close fullscreen on click outside the image
    fullscreenContainer.addEventListener('click', function(e) {
      if (e.target === fullscreenContainer) {
        document.body.removeChild(fullscreenContainer); // Remove fullscreen
      }
    });
  }

  // Zoom in function
  function zoomIn(img, event) {
    const rect = img.getBoundingClientRect(); // Get image dimensions and position
    const x = event.clientX - rect.left; // Calculate click X position relative to the image
    const y = event.clientY - rect.top; // Calculate click Y position relative to the image
    
    const xPercent = (x / rect.width) * 100; // Calculate the X percentage
    const yPercent = (y / rect.height) * 100; // Calculate the Y percentage

    img.style.transformOrigin = `${xPercent}% ${yPercent}%`; // Set the zoom origin
    img.style.transform = 'scale(2)'; // Adjust the scale to the zoom level
    img.style.cursor = 'zoom-out'; // Change the cursor to indicate zoom-out
  }

  // Zoom out function
  function zoomOut(img) {
    img.style.transform = 'scale(1)'; // Reset the scale to 1 (original size)
    img.style.transformOrigin = 'center'; // Reset the origin to the center
    img.style.cursor = 'zoom-in'; // Change the cursor to indicate zoom-in
  }
}

//scroll to button for products
//
//
  function scrollToElementTop(selector) {
    const el = document.querySelector(selector);
    if (el) {
      const yOffset = -100; // adjust this value if you have a fixed header (e.g., -100 for 100px tall navbar)
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }